export default "__VITE_ASSET__CtAsoo$z__"